import { jsx } from "panel";
import { LargeOptionEl } from "common/widgets/large-option";
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
function getEventHandlers(menu, option, focusedOption) {
  return {
    blur: () => {
      menu.helpers.updateFocusedOption(menu.helpers.FocusedTwoFactorOption.NO_FOCUS);
    },
    click: () => {
      menu.helpers.updateTwoFactorSelection(option);
    },
    focus: () => {
      menu.helpers.updateFocusedOption(focusedOption);
    },
    keydown: (ev) => {
      menu.helpers.callIfKeyboardInteraction(ev, () => {
        menu.helpers.updateTwoFactorSelection(option);
      });
    }
  };
}
function renderCurrentChipIf(shouldRender) {
  return shouldRender ? /* @__PURE__ */ jsx(TextHighlightEl, { attrs: { text: `Current`, theme: TEXT_HIGHLIGHT_THEME.INFORMATION } }) : null;
}
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(
    LargeOptionEl,
    {
      attrs: {
        selected: this.state.highlightedTwoFactorOption === this.helpers.TwoFactorOption.TOTP,
        focused: this.state.focusedOption === this.helpers.FocusedTwoFactorOption.TOTP,
        tabindex: 0
      },
      on: getEventHandlers(this, this.helpers.TwoFactorOption.TOTP, this.helpers.FocusedTwoFactorOption.TOTP)
    },
    /* @__PURE__ */ jsx("span", { attrs: { slot: `label-title` } }, "Authentication App (Recommended)", ` `, renderCurrentChipIf(this.state.previousOption === this.helpers.TwoFactorOption.TOTP)),
    /* @__PURE__ */ jsx("p", { sel: ".label-text", attrs: { slot: `label-text` } }, "Use an app to get two-factor authentication codes. We recommend using apps such as", ` `, /* @__PURE__ */ jsx(
      "a",
      {
        attrs: {
          href: `https://support.google.com/accounts/answer/1066447`,
          target: `_blank`
        }
      },
      "Google Authenticator"
    ), `, `, /* @__PURE__ */ jsx(
      "a",
      {
        attrs: {
          href: `https://authy.com/download/`,
          target: `_blank`
        }
      },
      "Authy"
    ), ` and `, /* @__PURE__ */ jsx(
      "a",
      {
        attrs: {
          href: `https://www.microsoft.com/en-us/security/mobile-authenticator-app`,
          target: `_blank`
        }
      },
      "Microsoft Authenticator"
    ), ".")
  ), /* @__PURE__ */ jsx(
    LargeOptionEl,
    {
      attrs: {
        selected: this.state.highlightedTwoFactorOption === this.helpers.TwoFactorOption.SMS,
        focused: this.state.focusedOption === this.helpers.FocusedTwoFactorOption.SMS,
        tabindex: 0
      },
      on: getEventHandlers(this, this.helpers.TwoFactorOption.SMS, this.helpers.FocusedTwoFactorOption.SMS)
    },
    /* @__PURE__ */ jsx("span", { attrs: { slot: `label-title` } }, "SMS ", renderCurrentChipIf(this.state.previousOption === this.helpers.TwoFactorOption.SMS)),
    /* @__PURE__ */ jsx("p", { sel: ".label-text", attrs: { slot: `label-text` } }, "Mixpanel will send a unique verification code to a phone number of your choice via SMS.")
  ));
}
